/* drain: cabecera, mega menú, cajón móvil y reproductor de demos compartido */
if (!customElements.get('drain-header')) {
  customElements.define('drain-header', class DrainHeader extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-mega]')];
      this.burger = this.querySelector('.d-burger');
      this.drawer = this.querySelector('.d-drawer');
      this.openTimer = null; this.closeTimer = null;
      const canHover = window.matchMedia('(hover: hover)').matches;

      this.items.forEach((item) => {
        const btn = item.querySelector('.d-nav__link');
        btn.addEventListener('click', () => (item.classList.contains('is-open') ? this.close() : this.open(item)));
        if (canHover) {
          item.addEventListener('mouseenter', () => { clearTimeout(this.closeTimer); this.openTimer = setTimeout(() => this.open(item), 120); });
          item.addEventListener('mouseleave', () => { clearTimeout(this.openTimer); this.closeTimer = setTimeout(() => this.close(), 180); });
        }
        item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) this.close(item); });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const open = this.querySelector('.d-nav__item.is-open');
        if (open) { this.close(); open.querySelector('.d-nav__link').focus(); }
        if (this.classList.contains('is-drawer')) this.toggleDrawer(false);
      });

      this.burger && this.burger.addEventListener('click', () => this.toggleDrawer(true));
      this.querySelector('[data-drawer-close]')?.addEventListener('click', () => this.toggleDrawer(false));
      this.querySelector('.d-header__scrim')?.addEventListener('click', () => this.close());

      this.onScroll = this.onScroll.bind(this);
      this.lastY = window.scrollY;
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    open(item) {
      this.items.forEach((i) => { if (i !== item) this.close(i); });
      item.classList.add('is-open');
      item.querySelector('.d-nav__link').setAttribute('aria-expanded', 'true');
      item.querySelector('.d-mega')?.removeAttribute('hidden');
      this.classList.add('is-open');
    }

    close(item) {
      const list = item ? [item] : this.items;
      list.forEach((i) => {
        i.classList.remove('is-open');
        i.querySelector('.d-nav__link').setAttribute('aria-expanded', 'false');
      });
      if (!this.querySelector('.d-nav__item.is-open')) this.classList.remove('is-open');
    }

    toggleDrawer(show) {
      this.classList.toggle('is-drawer', show);
      this.burger.setAttribute('aria-expanded', String(show));
      document.documentElement.style.overflow = show ? 'hidden' : '';
      if (show) this.drawer.querySelector('[data-drawer-close]').focus();
      else this.burger.focus();
    }

    onScroll() {
      const y = window.scrollY;
      this.classList.toggle('is-solid', y > 10);
      // Se esconde al bajar y vuelve al subir (no mientras hay un menú abierto)
      const busy = this.classList.contains('is-open') || this.classList.contains('is-drawer');
      this.classList.toggle('is-hidden', !busy && y > 400 && y > this.lastY);
      this.lastY = y;
    }
  });
}

/* Reproductor compartido: cualquier botón [data-d-play="url"] en la web */
(() => {
  if (window.__drainPlayer) return;
  const audio = new Audio(); audio.preload = 'none';
  let current = null;
  const setState = (btn, playing) => { if (!btn) return; btn.classList.toggle('is-playing', playing); btn.setAttribute('aria-pressed', String(playing)); };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-d-play]');
    if (!btn) return;
    e.preventDefault();
    const src = btn.getAttribute('data-d-play');
    if (current === btn && !audio.paused) { audio.pause(); return; }
    setState(current, false);
    current = btn;
    if (audio.src !== src) audio.src = src;
    audio.play().then(() => setState(btn, true)).catch(() => setState(btn, false));
  });
  audio.addEventListener('pause', () => setState(current, false));
  audio.addEventListener('ended', () => setState(current, false));
  audio.addEventListener('play', () => { document.querySelectorAll('audio').forEach((a) => a !== audio && a.pause()); });
  window.__drainPlayer = audio;
})();
